import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.wallets.KycDetails.SelfieStep', {
    title: 'ID document verification',
    reason: 'You must attach a colour photograph to your licence for completing {companyName} onboarding process',
    docType: 'Selected document type',
    selfie: 'Selfie',
    requirements: 'JPG, PNG, PDF. Max 10 Mb',
    documentRequired: 'Document is required',
});
